import SharedHeader from '@/components/share/header'
import SharedFooter from '@/components/share/footer'

export default {
  name: 'skillDetail',
  components: {
    SharedHeader,
    SharedFooter
  },
  computed: {
    env () {
      return this.$store.getters.env
    },
    api () {
      return this.$store.getters.api
    },
    user () {
      return this.$store.getters.user
    },
    avatar () {
      return this.$store.getters.avatar
    }
  },
  data () {
    return {
      skill: {
        skill: ['']
      },
      list: [],
      loading: true,
      isModal: false,
      updating: false,
      orderOptions: [
        { text: '新着順', value: 1 }
      ],
      orderSelect: 1,
      isScore: false,
      selected: {
        student: {},
        score: [],
        input: [0, 0, 0]
      },
      score: [0.0, 0.0, 0.0],
      comment: ''
    }
  },
  mounted () {
    this.onInit()
  },
  methods: {
    onInit () {
      this.loading = true

      let pathParams = {
        skillId: this.$route.params.skillId
      }

      let additionalParams = {
        queryParams: {
          type: 'detail'
        }
      }

      this.$apig.get(this.api.SKILL, pathParams, additionalParams, {})
        .then(response => {
          this.skill = response.data.skill
          this.list = response.data.list
          this.loading = false
        })
    },
    getAvatar (avatarId) {
      return `${process.env.S3}/student/avatar/${avatarId}.png`
    },
    open () {
      this.updating = true

      let pathParams = {
        skillId: this.$route.params.skillId
      }

      let additionalParams = {
        queryParams: {
          type: 'publish'
        }
      }

      this.$apig.patch(this.api.SKILL, pathParams, additionalParams, {})
        .then(response => {
          this.isModal = false
          this.updating = false
          this.onInit()
        })
        .catch(err => {
          console.log(err)
          this.error = err.response.data
          this.isAlert = true
          window.scrollTo(0, 0)
          this.updating = false
        })
    },
    getIcon (i, score) {
      if (i <= Math.floor(score)) return 'star'
      else if (i > Math.floor(score) && i <= Math.round(score)) return 'star-half-alt'
      else return 'star'
    },
    openAnswer (item) {
      this.selected = item
      this.score = [0, 0, 0]
      this.comment = ''
      this.isScore = true
    },
    send () {
      this.updating = true

      let pathParams = {
        skillId: this.$route.params.skillId
      }

      let additionalParams = {
        queryParams: {
          type: 'score'
        }
      }

      let body = {
        studentId: this.selected.studentId,
        score: this.score,
        comment: this.comment
      }

      this.$apig.patch(this.api.SKILL, pathParams, additionalParams, body)
        .then(response => {
          this.isScore = false
          this.updating = false
          this.onInit()
        })
        .catch(err => {
          console.log(err)
          this.error = err.response.data
          this.isAlert = true
          window.scrollTo(0, 0)
          this.updating = false
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/skill/detail/detail.js